import { Store } from '@medusajs/medusa'

import axios from '@/core/axios'
import { StoreWithAverageRating } from 'stoux-shared-types/services/store'

export type WithAverageRating = {
    averageRating: number
}

export class StoreRepository {
    async getById(id: string): Promise<Store & WithAverageRating> {
        const { data } = await axios.get<{ store: Store & WithAverageRating }>(
            `/vendors/${id}`,
        )
        return data.store
    }

    async list(): Promise<StoreWithAverageRating[]> {
        const { data } = await axios.get<{ stores: StoreWithAverageRating[] }>(
            `/vendors`,
        )
        return data.stores
    }
}
